// app/javascript/packs/application.js

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
ActiveStorage.start()

////// jQuery
var jQuery = require('jquery')
// include jQuery in global and window scope (so you can access it globally)
// in your web browser, when you type $('.div'), it is actually refering to global.$('.div')
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;

// for Rails CMS
require("@nathanvda/cocoon")

////// import the bootstrap javascript module
import "bootstrap"
// import the application.scss we created for the bootstrap CSS (if you are not using assets stylesheet)
// import "../stylesheets/application"

// Bootstrap 4 custom file input. For Rails CMS.
import bsCustomFileInput from 'bs-custom-file-input'
window.bsCustomFileInput = bsCustomFileInput;

////// Swiper
import Swiper, { Navigation, Pagination } from 'swiper/core';
// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);
// make Swiper available everywhere
global.Swiper = Swiper;
window.Swiper = Swiper;

///// Lightgallery
import lightGallery from 'lightgallery';
global.lightGallery = lightGallery;
window.lightGallery = lightGallery;

////// Other custom JS
import "../js/custom_file_input"
import "../js/animate_fx-slider"
import "../js/slice_text"
import "../js/open-menu"
import "../js/slide_down_header"
import "../js/swiper_slider" 
import "../js/dropdown" 
import "../js/show-map"
import "../js/scroll_to_id"
import "../js/lightgallery"
